import React from "react";
import { BalanceCardProps } from "./types";
import { CircleIconContainer } from "@letsbit/milkylb";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";
import { walletsMessages } from "./messages";
import { useNavigate } from "react-router-dom";
import { FormatedValue } from "components/FormatedValue";

export const BalanceCard: React.FC<BalanceCardProps> = ({
  wallet,
  className,
  investment,
  onClick,
}) => {
  const navigate = useNavigate();
  return (
    <div
      onClick={() =>
        onClick ? onClick(wallet) : navigate(`/logged/balance/${wallet.id}`)
      }
      className={classNames(
        className,
        "max-w-xs cursor-pointer rounded-3xl p-6 shadow-[0px_1px_6px_0px_#00000014] transition-all hover:shadow-[0px_1px_18px_0px_#0000001F]",
      )}
    >
      <div className="flex items-center">
        <CircleIconContainer
          // classNameSvg="currency-operation-card__icon"
          icon={wallet.icon_url}
        />
        <label className="ml-2 text-ellipsis whitespace-nowrap font-semibold text-[--milkylb-color-neutral-400]">
          <FormattedMessage
            {...(walletsMessages[wallet.id as keyof typeof walletsMessages] ||
              walletsMessages.default)}
            values={{
              name: wallet.name.toLowerCase(),
            }}
          />
          {investment && (
            <p className="text-xs text-[--color-success]">
              <FormattedMessage
                {...walletsMessages.earningTna}
                values={{
                  tna: investment.strategy_rate_tna,
                }}
              />
            </p>
          )}
        </label>
      </div>
      <h3 className="mt-2 text-ellipsis whitespace-nowrap font-['Tomato_Grotesk'] text-2xl font-bold text-[--milkylb-color-neutral-800]">
        <FormatedValue
          value={wallet.total_balance}
          precision={wallet.precision}
        />{" "}
        {wallet.ticker_id.toUpperCase()}
      </h3>
    </div>
  );
};
